import React, { useState, useEffect } from 'react'
import { Calendar } from 'react-date-range'
import { ko } from 'react-date-range/dist/locale'
import { format } from 'date-fns'
import { TextInput, IconButton } from 'components'
import { backPressState } from 'store/atom/app-state-atom'
import { useRecoilValue } from 'recoil'

// react-date-range
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'

// css
import 'assets/style/elements/datepicker.scss'
import 'assets/css/calendar.css'

function DatePicker({
  value = new Date(),
  className = '',
  dateFormat = 'yyyy.MM.dd',
  placeholder = 'yyyy.mm.dd',
  disabled = false,
  isInput = true,
  changeDate = () => {},
  maxDate,
  style = {},
}) {
  const [calShow, setCalShow] = useState(false)
  const [date, setDate] = useState(format(value, dateFormat, { locale: ko }))
  const [select, setSelect] = useState(value)
  const backPress = useRecoilValue(backPressState)

  useEffect(() => {
    if (calShow) {
      setCalShow(false)
    }
  }, [backPress])

  const handleCal = () => {
    if (disabled) return
    setCalShow(!calShow)
  }

  const handleDate = (date) => {
    setDate(format(date, dateFormat, { locale: ko }))
    setSelect(date)
    changeDate(date)
    if (calShow) setCalShow(!calShow)
    // handleCal()
  }

  return (
    <>
      <div className={className}>
        {isInput ? (
          <TextInput
            icon="date"
            value={date}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={true}
            onClick={handleCal}
            iconOnClick={handleCal}
            style={style}
          />
        ) : (
          <div className={`date-guide mt8`}>
            <IconButton
              size="30"
              className="prev-arrow-btn"
              onClick={() => {
                const prevDate = new Date(select)
                prevDate.setDate(prevDate.getDate() - 1)
                handleDate(prevDate)
              }}
            />
            <strong onClick={handleCal}>{date}</strong>
            <IconButton
              size="30"
              className="next-arrow-btn"
              onClick={() => {
                const nextDate = new Date(select)
                nextDate.setDate(nextDate.getDate() + 1)
                handleDate(nextDate)
              }}
            />
            <span />
          </div>
        )}
      </div>
      {calShow && (
        <div className="calendar-modal">
          <div className="popup-dim" onClick={handleCal}></div>
          <div className="calendar-wrap">
            <header className={`site-header site-header-popup`} style={{ padding: '0', height: '25px' }}>
              <div className="row relative" style={{ height: '26px', backgroundColor: '#ffffff' }}>
                <div className="right" style={{ top: '0px' }}>
                  <IconButton size="20" bg="white" type="close" onClick={handleCal} />
                </div>
              </div>
            </header>
            <Calendar
              date={select}
              onChange={handleDate}
              dateDisplayFormat={dateFormat}
              locale={ko}
              {...(maxDate ? { maxDate } : {})}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default DatePicker
